module.exports = __webpack_public_path__ + "static/media/bg_gallery.5df01d8f.jpg";